angular.module('backstage.controllers.features', []);

require('./EventPackagesManagerCtrl');
